export default "__VITE_PUBLIC_ASSET__a23f5c1e__"